<template>
  <div ref="PaginationButtons" class="pagination-buttons flex transparent">
    <div :class="[ 'pagination-buttons-container flex text-center', { 'disabled': !pageToMove.left } ]">
      <button
        @click="moveToPage('left')"
        :disabled="!pageToMove.left"
        type="button"
        class="pagination-buttons-container-cta"
      >
        <font-awesome-icon :icon="[ 'fas', 'caret-left' ]" />
      </button>
      <span class="pagination-buttons-container-text">{{ $t('subnavigation.previous') }}</span>
    </div>
    <div :class="[ 'pagination-buttons-container flex text-center', { 'disabled': !pageToMove.right } ]">
      <button
        @click="moveToPage('right')"
        :disabled="!pageToMove.right"
        type="button"
        class="pagination-buttons-container-cta"
      >
        <font-awesome-icon :icon="[ 'fas', 'caret-right' ]" />
      </button>
      <span class="pagination-buttons-container-text">{{ $t('subnavigation.next') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaginationButtons',
  props: {
    /*
     * @property - pages
     * Pages to navigate across
     */
    pages: {
      type: Array,
      required: true
    }
  },
  computed: {
    /*
     * @computed - pageToMove
     * Gets left and right pages to move if exists, otherwise its value will be null
     */
    pageToMove() {
      const currentPageIndex = this.$props.pages.indexOf(this.$route.name);

      const left = currentPageIndex === -1 || currentPageIndex - 1 < 0
        ? null
        : this.$props.pages[currentPageIndex - 1];
      const right = currentPageIndex === -1 || currentPageIndex + 1 > this.$props.pages.length
        ? null
        : this.$props.pages[currentPageIndex + 1];

      return { left, right };
    }
  },
  methods: {
    /*
     * @function - moveToPage
     * This function moves user to next or previous page. Appends idioma query param if exists
     * @param - type (String): Defines direction to move if exists (right or left)
     */
    moveToPage(type = 'right') {
      if (this.pageToMove[type]) {
        const language = this.$route.query && this.$route.query.idioma;
        const newRoute = { name: this.pageToMove[type] };

        if (language) {
          newRoute.query = { idioma: language };
        }

        this.$router.push(newRoute);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .pagination-buttons {
    margin: 2.5rem 0 1rem;

    &-container {
      flex: 1 0 50%;
      flex-direction: column;

      &.disabled {
        opacity: 0.45;
      }

      &-cta {
        @include fillHorizontalTransition($white-raw, $dark-gray, $white-raw, $main-blue, true);
        border: none;
        border-radius: 0.2rem;
        box-shadow: 0.2rem 0.2rem 0.25rem 0 rgba($dark-raw, 0.4);
        display: inherit;
        font-size: 2rem;
        margin: auto;
        padding: 0.25rem 0.5rem;

        .fas {
          margin: inherit;
        }
      }

      &-text {
        font-size: 0.85rem;
        margin-top: 0.5rem;
      }
    }
  }
</style>
